import _ from 'underscore';

import isArchived from 'archive/isArchived';
import {AssayLinkSchemaField, FieldType} from 'schemas/fields/SchemaFieldConstants';
import {Optional} from 'util/Types';

import {AssaySchema} from './assay-schemas/AssaySchemaConstants';

function isLegalResultSchema(schema: AssaySchema, runSchemaId: Optional<string>): boolean {
  const runLinkField = _.findWhere(schema.fields, {
    fieldType: FieldType.ASSAY_RUN_LINK,
  }) as AssayLinkSchemaField;
  if (!runLinkField) {
    return false;
  }
  if (isArchived(schema)) {
    return false;
  }
  if (runSchemaId && runLinkField.requiredLink && runLinkField.requiredLink.assaySchema) {
    return runSchemaId === runLinkField.requiredLink.assaySchema.id;
  }
  return true;
}

export default function legalResultSchemasForRun(
  schemas: Array<AssaySchema>,
  runSchemaId: Optional<string>
): Array<AssaySchema> {
  return schemas.filter((schema) => isLegalResultSchema(schema, runSchemaId));
}
